"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultConsentTextWithCompanyName = getDefaultConsentTextWithCompanyName;
exports.default = getDefaultConsentText;

var _I18n = _interopRequireDefault(require("I18n"));

var _fetchCompanyName = _interopRequireDefault(require("./fetchCompanyName"));

function getDefaultConsentTextWithCompanyName(field, _ref) {
  var locale = _ref.locale,
      companyName = _ref.companyName;

  if (field === 'communicationConsentCheckboxes') {
    return JSON.stringify([{
      communicationTypeId: null,
      label: _I18n.default.text("SharedLegalStrings.consent." + field + ".label", {
        locale: locale,
        companyName: companyName
      })
    }]);
  } else {
    return _I18n.default.text("SharedLegalStrings.consent." + field, {
      locale: locale,
      companyName: companyName
    });
  }
}

function getDefaultConsentText(field, _ref2) {
  var locale = _ref2.locale;
  return (0, _fetchCompanyName.default)().then(function (companyName) {
    return getDefaultConsentTextWithCompanyName(field, {
      locale: locale,
      companyName: companyName
    });
  });
}